var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-popover',{attrs:{"boundariesElement":".l-main","handleResize":false,"placement":_vm.placement,"popoverClass":_vm.popoverClass,"trigger":"hover","disabled":_vm.isDisabled}},[_vm._t("default"),_c('template',{slot:"popover"},[_vm._t("popover",function(){return [_vm._t("default")]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }